import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["arrival"]
  declare readonly arrivalTargets: HTMLInputElement[]

  occupancySelected(e: InputEvent): void {
    const selectedOccupancy = (e.currentTarget as HTMLInputElement).value
    const selectedArrival = this.arrivalTargets.find((target) => target.checked)?.value

    // Hide arrival options that don't correspond to selected occupancy
    const availableArrivalOptions = this.arrivalTargets.flatMap((target) => {
      const label = target.parentElement as HTMLLabelElement
      label.hidden = target.dataset.occupancy !== selectedOccupancy
      return label.hidden ? [] : [target]
    })

    // Select the first available arrival if the current selected is unavailable
    const selected = availableArrivalOptions.find((option) => option.value === selectedArrival)
    const first = availableArrivalOptions.at(0)
    const arrival = selected || first
    arrival!.checked = true
  }
}
